import { Box, VStack } from '@cardboard-ui/react';
import React, { FC } from 'react';
import { RemirrorJSON } from 'remirror';
import './page-thumbnail.css';
import ThumbnailRemirrorRenderer from './ThumbnailRemirrorRenderer';

interface PageThumbnailProps {
  data: RemirrorJSON | string;
  fallback: React.ReactElement;
}

const PageThumbnail: FC<PageThumbnailProps> = ({ data, fallback }) => {
  return (
    <Box w="100%" h="100%">
      <VStack w="100%" h="100%" alignContent="center">
        <Box
          p={3}
          paddingTop={7}
          bgColor="gray.50"
          _dark={{ bg: 'gray.600' }}
          h="100%"
          fontSize="70%"
          w="100%"
          className="thumbnail-renderer"
          overflow="hidden"
        >
          <ThumbnailRemirrorRenderer json={data} fallback={fallback} />
        </Box>
      </VStack>
    </Box>
  );
};

export default PageThumbnail;
